import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _filter from 'lodash/filter';
import {
  getInvitations,
  createInvitation,
  deleteInvitation,
  clearLocalInvitations
} from './actions';

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 10, offset: 0, count: 0, total_count: 0 } 
  },
  invitation: { 
    id: '', 
    email: '', 
    updated_at: '' 
  },
  loading: { 
    all: false, 
    invitation: false 
  }
};

const  slice = createSlice({
  name: 'invitations',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getInvitations.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getInvitations.fulfilled, (state, action) => {
        const { invitations, pagination } = action.payload;
        
        state.loading.all = false;
        state.all =  { ...state.all, data: [...state.all.data, ...invitations], pagination };
      })
      .addCase(getInvitations.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(createInvitation.pending, (state) => {
        state.loading.invitation = true;
      })
      .addCase(createInvitation.fulfilled, (state, action) => {
        const { invitation } = action.payload;
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = [...[invitation], ...oldAllData];
        const pagination = { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.invitation = false;
        state.all = { ...state.all, data, pagination };
        state.invitation = invitation;  
      })
      .addCase(createInvitation.rejected, (state) => {
        state.loading.invitation = false;
      })
      .addCase(deleteInvitation.pending, (state) => {
        state.loading.invitation = true;
      })
      .addCase(deleteInvitation.fulfilled, (state, action) => {
        const { status, id } = action.payload;
        
        state.loading.invitation = false;
        if (status === 204) {
          state.all.data = _filter(state.all.data, (item) => item.id !== id);
          state.all.pagination = { ...state.all.pagination, count: state.all.pagination.count - 1, total_count: state.all.pagination.total_count - 1 };
          state.invitation = initialState.invitation;
        }
      })
      .addCase(deleteInvitation.rejected, (state) => {
        state.loading.invitation = false;
      })
      .addCase(clearLocalInvitations, state => {
        state.all = initialState.all;
      })
  }
})

export default slice.reducer;